import { useNavigate } from "react-router-dom";
import {clearTokens} from "../api/authApi";

export const useLogoutHandle = () => {
    const navigate = useNavigate();

    return () => {
        clearTokens();
        navigate("/login");
    };
};
